<app-layout></app-layout>
<p-toast #toast position="top-right" styleClass="mobile-toast" [baseZIndex]="9999999"></p-toast>
<app-loader></app-loader>
<div class="login-loader-container" *ngIf="showLoginLoader">
  <div class="login-loader">
    <div class="login-loader-icon" [innerHTML]="loaderIcon | safeHtml"></div>
  </div>
  <div class="login-loading-text">
    <div class="login-loader-heading">Hang tight…</div>
    <div class="login-loader-text">We’re finding your account</div>
  </div>
</div>
<router-outlet name="modal"></router-outlet>
